import { render, staticRenderFns } from "./TepGraficaTotalVh.vue?vue&type=template&id=134b6b17"
import script from "./TepGraficaTotalVh.vue?vue&type=script&lang=js"
export * from "./TepGraficaTotalVh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports